document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(".scroll-reveal");

  function checkVisibility() {
    elements.forEach(element => {
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const triggerPoint = windowHeight * 0.8;
      const isInView = rect.top <= triggerPoint && rect.bottom >= 0;

      if (isInView) {
        element.classList.add("in-view");
      } else {
        element.classList.remove("in-view");
      }
    });
  }

  window.addEventListener("scroll", checkVisibility);
  window.addEventListener("resize", checkVisibility);

  checkVisibility();
});
